import { Reveal, SectionLabel } from './Reveal';

export const Welcome = () => (
  <section
    id="welcome"
    data-testid="welcome-section"
    className="relative border-t border-white/5 bg-navy-950 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <SectionLabel>Welcome</SectionLabel>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <p className="font-serif text-2xl leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl text-balance">
              Welcome to London Biotech International — a specialist vehicle
              formed to plan, structure and deliver the infrastructure that
              modern life sciences and healthcare demand.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 lg:text-lg">
              We exist to bridge ambition and execution. From national health
              programmes to research campuses, we bring together the
              disciplines, capital and governance required to turn a vision into
              enduring, operational reality — with the discretion and rigour our
              partners expect.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
